<template>
  <canvas ref="canvas"></canvas>
</template>
<script>
export default {
  props: ["data"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    renderChart() {
      const canvas = this.$refs.canvas;
      let scaleUnit = 1;
      let min = 0;
      let max = 0;
      let absMax = 0;
      this.data.forEach(d => {
        if (d > max) {
          max = d;
        }
        if (d < min) {
          min = d;
        }
        absMax = Math.max(Math.abs(min), max);
        if (absMax !== 0) {
          scaleUnit = (canvas.height / 2 - 10) / absMax;
        }
      });
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "black";
      ctx.font = "10px serif";
      let start = {
        x: 0,
        y: canvas.height / 2 - 5 - this.data[0] * scaleUnit
      };
      this.data.forEach(d => {
        const end = {
          x: start.x + canvas.width / 500,
          y: canvas.height / 2 - 5 - d * scaleUnit
        };
        this.drawLine(ctx, start.x, start.y, end.x, end.y);
        start = end;
      });
      /*
        // draw marker
        if (min === 0 && max === 0) {
          return;
        }
        ctx.setLineDash([3, 5]);
        ctx.beginPath();
        const maxOffset = ((canvas.height / 2) - 5) - (max * scaleUnit);
        const minOffset = ((canvas.height / 2) - 5) - (min * scaleUnit);
        ctx.moveTo(0, maxOffset);
        ctx.lineTo(canvas.width, maxOffset);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, minOffset);
        ctx.lineTo(canvas.width, minOffset);
        ctx.stroke();
        ctx.fillText(max, 5, 10);
        ctx.fillText(min, 5, canvas.height - 10);
        */
    },
    drawLine(ctx, startX, startY, endX, endY) {
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();
    }
  },
  watch: {
    data() {
      this.renderChart();
    }
  }
};
</script>
